import { z } from "zod";
import { nonEmptyString } from "../zod/nonEmptyString.js";

export const contactButtonBlockSchema = z.object({
	text: nonEmptyString,
});
